const MANAGER_IMAGE_ORIGIN = 'https://iskenderun.bel.tr';

export const resolveManagerImageUrl = (value) => {
  if (typeof value !== 'string' || !value.trim()) return '/placeholder-manager.jpg';
  let path = value.trim().replace(/\\/g, '/');
  if (/^(?:data:|blob:)/i.test(path)) return path;

  if (/^(?:https?:)?\/\//i.test(path)) {
    try {
      const url = new URL(path, MANAGER_IMAGE_ORIGIN);
      path = `${url.pathname}${url.search}${url.hash}`;
    } catch {
      return '/placeholder-manager.jpg';
    }
  }

  path = path.replace(/^\/+/, '');
  // Imported records can contain both a domain/ placeholder and repeated origins.
  const prefix = /^(?:domain|(?:(?:https?:)?\/\/)?(?:www\.)?iskenderun\.bel\.tr)(?:\/+|$)/i;
  while (prefix.test(path)) path = path.replace(prefix, '');

  return path ? `${MANAGER_IMAGE_ORIGIN}/${path}` : '/placeholder-manager.jpg';
};
